




import { Vue } from 'vue-property-decorator';

export default class Home extends Vue {}
